import { isPathMatch } from '@/utils/common'
//路由白名单
const whiteList = ['/login', '/404', '/']

const isWhiteList = (path) => {
  return whiteList.some((pattern) => isPathMatch(pattern, path))
}

const isPathMatch2 = (whitelist,path) => {
  const decodedPath = decodeURIComponent(path)
  // 1.完全匹配
  if (whitelist.some(item => item === decodedPath)) {
    return true
  }

  //2.拥有我的文件权限
  if(whitelist.includes('/resource/folder/%2F') !==-1 && decodedPath.startsWith('/resource/folder/')) {
    return true
  }
  return false
}

export default ({ app, store, redirect }) => {
  if (process.client) {
    app.router.beforeEach((to, from,next) => {
      if (isWhiteList(to.path)) {
        return next()
      }
      const routers = store.state.routers
      const list = routers.flatMap((item) =>
        item.children.map((child) =>
          `${item.path}/${child.path}`.replace(/\/+/g, '/')
        )
      )
      if (isPathMatch2(list,to.path)) {
        return next()
      }
      return next('/404')
    })
  }
}
